module.exports = __webpack_public_path__ + "static/media/tan.42c17dcd.jpg";